import { useTranslation } from "react-i18next"

import { FilterChip } from "@/components/filter-chip"
import { FilterToolbar } from "@/components/filter-toolbar"
import { PRODUCT_TYPE_VALUES } from "@/features/contracts/components/contract-constants"

const STATUSES = ["OPEN", "IN_PROGRESS", "DELIVERED", "CANCELLED"] as const

export interface ContractsFiltersValue {
  search: string
  status: string
  product: string
}

interface ContractsSearchFiltersProps {
  value: ContractsFiltersValue
  onChange: (next: ContractsFiltersValue) => void
}

export function ContractsSearchFilters({
  value,
  onChange,
}: ContractsSearchFiltersProps) {
  const { t } = useTranslation(["contracts", "common"])
  const allLabel = t("common.all", { ns: "common" })

  let activeCount = 0
  if (value.status !== "all") activeCount += 1
  if (value.product !== "all") activeCount += 1

  return (
    <FilterToolbar
      search={value.search}
      onSearchChange={(v) => onChange({ ...value, search: v })}
      searchPlaceholder={t("search.placeholder")}
      activeFilterCount={activeCount}
      resetLabel={t("search.clearFilters")}
      onReset={() => onChange({ search: "", status: "all", product: "all" })}
    >
      <FilterChip
        label={t("search.statusLabel")}
        value={value.status}
        onValueChange={(v) => onChange({ ...value, status: v })}
        options={STATUSES.map((s) => ({ value: s, label: t(`status.${s}`) }))}
        allLabel={allLabel}
      />
      <FilterChip
        label={t("search.productLabel")}
        value={value.product}
        onValueChange={(v) => onChange({ ...value, product: v })}
        options={PRODUCT_TYPE_VALUES.map((p) => ({
          value: p,
          label: t(`options.productTypes.${p}`),
        }))}
        allLabel={allLabel}
      />
    </FilterToolbar>
  )
}
